import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { IDynamicComponent } from '../../../dynamic-component/IDynamicComponent';

@Component({
  selector: 'ps-data-grid-detail-row',
  templateUrl: './data-grid-detail-row.component.html',
  styleUrls: ['./data-grid-detail-row.component.css']
})
export class DataGridDetailRowComponent implements OnInit {

  @Input() model: any;
  @Input() detailComponentOption: (m: any) => IDynamicComponent;

  dynamicComponent: IDynamicComponent;
  
  constructor() { 
  }

  ngOnInit() {
    this.dynamicComponent = this.detailComponentOption(this.model);
  }
}
